import BaseAPI from "@/apis/base/base-api";
import httpClient from "@/apis/base/axios-httpclient";

class TransferAPI extends BaseAPI {
  constructor() {
    super();
  }
  apiName = "Business";
  controllerName = "Transfer";

  /**
   * @override: Lấy dữ liệu danh sách
   * @author ntnghia - 26.03.2021
   */
  getList(payload) {
    // URL mặc định
    let url = this.getAPIUrl() + "/list";

    // Nếu là form điều chuyển vị trí tài sản
    if (payload.type == "location") {
      url = this.getAPIUrl() + "/transfer-location";
    }
    // Nếu là form điều chuyển đối tượng sử dụng
    else if (payload.type == "user") {
      url = this.getAPIUrl() + "/transfer-user";
    }
    // Nếu là form điều chuyển đơn vị quản lý
    else if (payload.type == "management") {
      payload.columns =
        "TransferStatus,DenyReason,TransferNo,TransferDate,FromManagementName,FromManagerName,ToManagementName,ToManagerName,Quantity,Reason,TransferID,IsTransferMulti,IsByQuantity,AssetID, Editable,Acceptable,UserID,ToManagerID";
      url = this.getAPIUrl() + "/transfer-management";
    }

    // Build tham số
    let request = {
      url: url,
      data: payload,
    };

    // Call api
    return httpClient.postAsync(request);
  }

  /**
   * Author: ĐVThi
   * Date create: 01/03/2021
   * Tìm kiếm tài sản theo nhiều đối tượng
   */
  getBalanceAssetbyObjectID(objectid, searchType) {
    let request = {
      url: [this.getAPIUrl(), "list-asset", searchType, objectid].join("/"),
    };
    return httpClient.getAsync(request);
  }

  /** author: ntnghia
   *  Create date: 17/03/2021
   *  Lấy danh sách lịch sử phát sinh nghiệp vụ tài sản trong biên bản điều chuyển
   */
  getUsageHistoryByTransferID(payload) {
    let request = {
      url: [this.getAPIUrl(), "usage-history-transferid"].join("/"),
      data: payload,
    };

    return httpClient.postAsync(request);
  }

  // lấy dữ liệu cho view transfer
  getTransferByTransferID(payload) {
    let request = {
      url: [this.getAPIUrl(), "transfer-by-transferid"].join("/"),
      data: payload,
    };

    return httpClient.postAsync(request);
  }

  /** author: ntnghia
   *  Create date: 30/03/2021
   *  Lấy danh sách biên bản điều chuyển đơn vị quản lý để show noti
   */
  getTotal() {
    return 0;
  }
}

export default new TransferAPI();
